import { Image } from "antd";

export default function Logo({ src = "/logo.png" }) {
  return (
    <Image
      preview={false}
      src={src}
      style={{
        width: 150,
      }}
    />
  );
}
